import { Buffer } from "buffer";

export class FilesUtility {
    public static convertBinaryToBase64(content: string): string {
        return Buffer.from(content).toString("base64");
    }

    public static createObjectUrl(content: string, contentType: string): string {
        let byteNumbers = new Array(content.length);
        for (let i = 0; i < content.length; i++) {
            byteNumbers[i] = content.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], { type: contentType });

        return URL.createObjectURL(blob);
    }

    public static downloadContentAsFile(content: string, contentType: string, fileName: string) {
        let dataObjectUrl = this.createObjectUrl(content, contentType);
        this.downloadUrlAsFile(dataObjectUrl, fileName);
        
        URL.revokeObjectURL(dataObjectUrl);
    }

    public static downloadUrlAsFile(url: string, fileName: string) {
        let jLink = jQuery("<a style='display: none;'></a>").attr({
            href: url,
            download: fileName
        });

        jQuery("body").append(jLink);
        jLink[0].click();
        jLink.remove();
    }
}